import { useContext } from 'react';
import { PDFContext } from '../pdf-provider';
export default function usePDF() {
  return useContext(PDFContext);
}